import React, { Children, cloneElement, isValidElement, memo, useMemo } from 'react';
import PropTypes from 'prop-types';

const List = ({ items, type = 'unordered', ...otherProps }) => {
    const ListComponent = useMemo(() => (type === 'ordered' ? 'ol' : 'ul'), [type]);

    const listItems = useMemo(
        () =>
            Children.toArray(items)
                .filter((item) => isValidElement(item))
                .map((item, index) => cloneElement(item, { key: item.key ?? index })),
        [items],
    );

    return <ListComponent {...otherProps}>{listItems}</ListComponent>;
};

List.displayName = 'MarkdownList';

List.propTypes = {
    items: PropTypes.node.isRequired,
    type: PropTypes.oneOf(['ordered', 'unordered']),
};

export default memo(List);
